module.exports = __webpack_public_path__ + "amcharts/images/xIcon.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/xIcon.svg
// module id = 284
// module chunks = 0